import {useMutation} from '@tanstack/react-query';
import proposalUpdaters from '@/api/updaters/proposals';

function useBulkProposalAction() {
  return useMutation({
    mutationKey: ['proposals', 'batch'],
    mutationFn: proposalUpdaters.batch,
  });
}

export default useBulkProposalAction;
